import { StreamingClient } from '@/lib/streamingClient';
import type { InterpreterSocketContext } from './interpreter.types';

export const connectInterpreterSocket = async ({
  id,
  client,
  currentTurn,
  mounted,
  onChanged,
  onPartial,
  onDisconnect,
}: InterpreterSocketContext) => {
  if (client.current?.isConnected()) return;
  client.current?.disconnect();
  const connection = new StreamingClient();
  client.current = connection;
  await connection.connect();
  const socket = connection.getSocket();
  if (!socket) throw new Error('connection_failed');
  socket.on('interpreter_changed', (event: { id: string }) => {
    if (event.id === id) onChanged();
  });
  socket.on('interpreter_partial', (event: { id: string; turn_id: string; text: string }) => {
    if (event.id === id && event.turn_id === currentTurn.current && mounted.current) onPartial(event.text);
  });
  socket.on('disconnect', () => {
    if (connection === client.current) onDisconnect();
  });
};
